import {getAxiosClientWithJWTToken} from 'api';
import { handleFormData } from 'lib/utils';
import {RegisterFacilityTypeData, facilityTypeData} from 'types'

export const createFacilityType = (params: RegisterFacilityTypeData) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.post(`/facilitytypes/create`, params);
};

export const getListFacilityType = (params: {} ) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.get('/facilitytypes', { params });
};

export const UpdateFacilityType = (params: { uuid: string, name: string }) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.post(`/facilitytypes/update`, params);
};
